/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Atul Kumar",
  title: "Hi all, I'm Atul",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JAVA/ JavaScript / Nestjs / Vuejs / Reactjs / Nodejs / Spring Boot/ SQL and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ZdMA8JEO3YpIZPk4phPXUeE39uYTf1Cr/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/AtulKumar112",
  linkedin: "https://www.linkedin.com/in/atul-kumar-saini-40a5601b5/",
  gmail: "atul.kumar112000@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/profile.php?id=100006023566684",
  // medium: "https://medium.com/@saadpasta",
  stackoverflow:
    "https://stackoverflow.com/users/16351393/atul-kumar?tab=profile",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Create robust server-side applications with Nest.js with Node.js, powered by TypeScript for maintainability"
    ),
    emoji(
      "⚡ Utilize Java for specific backend functionalities, ensuring flexibility."
    ),
    emoji(
      "⚡ Implement API integration with Vue.js and React.js for client side app."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java" // Add the Java icon class here
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code" // Using the "code" icon for TypeScript
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Nest.js",
      fontAwesomeClassname: "fas fa-cat" // Using a bird icon for Nest.js
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },

    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },

    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs" // Add the Vue.js icon class here
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },

    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },

    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database" // Using the "database" icon for PostgreSQL
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git" // Using a Git icon
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github" // Using a GitHub icon
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Dr. A.P.J. Abdul Kalam Technical University",
      logo: require("./assets/images/aktu"),
      subHeader: "Bachelor of Technology in Computer Science & Engineering",
      duration: "August 2017 - August 2021"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming",
      progressPercentage: "94%"
    },
    {
      Stack: "Backend",
      progressPercentage: "88%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "68%" //Insert relative proficiency in percentage
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Digantara",
      companylogo: require("./assets/images/digantara.png"),
      date: "May 2023 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Proficiently drove NestJS-based API development, harnessing PostgreSQL with Timescale extension for robust data storage, and utilizing Redis for caching optimization.",
        "Skillfully managed a Docker environment hosting Timescale, Redis, RabbitMQ, and SQL migrator components, showcasing adeptness in containerization.",
        "Developed and optimized APIs, employing Sequelize with NestJS to facilitate seamless database interactions and management.",
        "Ensured data integrity and consistency by integrating PostgreSQL with Timescale, leveraging its time-series capabilities.",
        "Also works front-end development projects using cutting-edge technologies such as HTML, CSS, JavaScript, Vue.js, Tailwind and chota CSS to deliver visually stunning and highly responsive user interfaces.",
        "Handled data integration from a REST API endpoint, ensuring efficient processing and display of the information.",
        "Implemented robust and scalable front-end solutions using Vue.js framework, leveraging its reactive components and state management to enhance performance and user interactivity.",
        "Utilized Tailwind and Chota CSS framework to streamline UI development, rapidly prototyping and iterating on designs while maintaining code cleanliness and modularity."
      ]
    },
    {
      role: "Software Engineer",
      company: "Capgemini",
      companylogo: require("./assets/images/capgemini.png"),
      date: "April 2022 – April 2023",
      descBullets: [
        "I’m a Full Stack Developer experienced in e-commerce with a focus on SAP Hybris, built on Java Spring Boot.",
        "Tailored and optimized the Product Detail Page (PDP), Product Listing Page (PLP), and Payment Detail Page in response to client specifications on the e-commerce platform.",
        "Proficiently utilized SAP Hybris tools, including HAC and BackOffice, for efficient data management."
      ]
      // desc: "",
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Leetcode",
      subtitle:
        "Solved over 500+ Java problems on LeetCode. Achieved a maximum contest rating of 1490. Maintained a daily coding challenge streak from July 12, 2022, to the present.",
      image: require("./assets/images/leetcode.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Visit",
          url: "https://leetcode.com/atul9119"
        }
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "GeeksForGeeks",
      subtitle:
        "Solved over 400+ Java problems and Maintained the POTD streak from Augest 29, 2022 to the persent and got the gfg goodies (bag & shirt)",
      image: require("./assets/images/gfg.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Visit",
          url: "https://auth.geeksforgeeks.org/user/atulkumar112000/practice"
        }
      ]
    },

    {
      title: "Hacker Rank",
      subtitle:
        "Secure the 5 stars in JAVA, Problem Solving, SQL & Python and got certificates",
      image: require("./assets/images/hackerrank.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        // {name: "Certification", url: ""},
        {
          name: "Visit",
          url: "https://www.hackerrank.com/atul_kumar112000"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9119785897",
  email_address: "atul.kumar@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "astronautatul", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
